import { render, staticRenderFns } from "./BlackbodyViz.vue?vue&type=template&id=59c0929e&scoped=true"
import script from "./BlackbodyViz.vue?vue&type=script&lang=js"
export * from "./BlackbodyViz.vue?vue&type=script&lang=js"
import style0 from "./BlackbodyViz.vue?vue&type=style&index=0&id=59c0929e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c0929e",
  null
  
)

export default component.exports